import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import withShallowComparison from '../../Common/withShallowComparisonUpdate';

import InputWrapper from '../WrapperInput';
import Checkbox from '../Checkbox';
import InputTextArea from '../TextArea';
import Icon from '../../Common/Icon';
import ConfigService from "../../../Services/api/Config";
import Utils from '../../../Services/Utils';

import './style.scss';
import {ReactComponent as PhotoIcon} from "../../../../img/widget-attachment-photo.svg";
import {ReactComponent as FileIcon} from "../../../../img/icon-upload.svg";
import {ReactComponent as FileGenericIcon} from "../../../../img/files/icon-generic.svg";
import {ReactComponent as FileImageIcon} from "../../../../img/files/icon-image.svg";
import {ReactComponent as FileAudioIcon} from "../../../../img/files/icon-audio.svg";
import {ReactComponent as FileVideoIcon} from "../../../../img/files/icon-video.svg";
import {ReactComponent as FileExcelIcon} from "../../../../img/files/icon-excel.svg";
import {ReactComponent as FilePPTIcon} from "../../../../img/files/icon-ppt.svg";
import {ReactComponent as FileTextIcon} from "../../../../img/files/icon-text.svg";
import {ReactComponent as FileZipIcon} from "../../../../img/files/icon-zip.svg";
import {ReactComponent as FilePDFIcon} from "../../../../img/files/icon-pdf.svg";

class InputFile extends React.PureComponent {

  componentDidMount() {
    this.initValidate();
  }

  componentDidUpdate() {
    this.initValidate();
  }

  initValidate = () => {
    const { value, onError, error } = this.props;
    const newError = this.validate(value);
    if (onError && !Utils.equals(newError, error)) onError(newError);
  }

  validate = (value) => {
    const { required, validators } = this.props;
    if (required && Utils.isEmpty(value)) return 'This field is required.';
    for (const validator of validators || []) {
      if (validator(value)) return validator(value);
    }
    return '';
  };

  remove = (index) => {
    const { value, onChange, onError, error } = this.props;
    if (value) {
      value.splice(index, 1);
    }
    const result = value && value.length > 0 ? [...value] : null;
    if (onChange) onChange(result);
    const newError = this.validate(result);
    if (onError && !Utils.equals(newError, error)) onError(newError);
  };

  getDefaultValue = (value) => {
    let files = [];
    if (value) {
      if (Array.isArray(value)) {
        value.filter(Boolean).forEach((result) => {
          return files.push(result.id ?
            {url: result.file, file: result.file, name: result.name, id:result.id, comment_active: result.comment_active, comment: result.comment} : result);
        });
      }
      else {
        files.push(value ?
          {url: value.file, file: value.file, name: value.name, id:value.id, comment_active: value.comment_active, comment: value.comment} : value);
      }
    }
    return files;
  };

  activeComment = (index) => {
    const { value, onChange, onError, error } = this.props;
    if (value) {
      value[index].comment_active = !value[index].comment_active;
    }
    const result = value && value.length > 0 ? [...value] : null;
    if (onChange) onChange(result);
    const newError = this.validate(result);
    if (onError && !Utils.equals(newError, error)) onError(newError);
  };

  changeComment = (comment, index) => {
    const { value, onChange, onError, error } = this.props;
    if (value) {
      value[index].comment = comment;
    }
    const result = value && value.length > 0 ? [...value] : null;
    if (onChange) onChange(result);
    const newError = this.validate(result);
    if (onError && !Utils.equals(newError, error)) onError(newError);
  };

  getName = (url) => {
    if (!url) return '';
    const arrayUrl = url.split('\\');
    return arrayUrl[arrayUrl.length - 1];
  };

  getType = (url) => {
    if (!url) return 'generic';
    let classes = '';
    const arrayUrl = url.split('.');
    switch (arrayUrl[arrayUrl.length - 1]) {
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
      case 'svg':
      case 'bmp':
        classes = 'image';
        break;
      default:
        classes = 'generic';
        break;
    }
    return classes;
  };

  getClassesType = (url) => {
    if (!url) return '';
    const arrayUrl = url.split('.');
    return arrayUrl[arrayUrl.length - 1];
  };

  getIcon = (file) => {
    switch (this.getClassesType(file.name)) {
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
      case 'svg':
      case 'bmp':
        return <FileImageIcon alt={file.name} />;
      case 'mp4':
      case 'mkv':
      case 'wmv':
      case 'avi':
      case 'mov':
      case 'mpg':
      case 'mpeg':
        return <FileVideoIcon alt={file.name} />;
      case 'pdf':
        return <FilePDFIcon alt={file.name} />;
      case 'xls':
      case 'xlsx':
        return <FileExcelIcon alt={file.name} />;
      case 'ppt':
      case 'pptx':
        return <FilePPTIcon alt={file.name} />;
      case 'txt':
      case 'doc':
      case 'docx':
        return <FileTextIcon alt={file.name} />;
      case 'zip':
      case 'rar':
      case 'gzip':
        return <FileZipIcon alt={file.name} />;
      case 'mp3':
      case 'mid':
      case 'midi':
      case 'wav':
      case 'aac':
      case 'ac3':
      case 'm4a':
        return <FileAudioIcon alt={file.name} />;
      default:
        return <FileGenericIcon alt={file.name} />;
    }
  };

  handleChange = async (e) => {
    const { onChange, onError, error, value } = this.props;
    const values = e.target ? e.target.files : e;
    let files = value ? value.filter(Boolean).concat([...values]) : [...values];
    let filesData = files.filter(Boolean).map((file) => {
      if (!file.id && file instanceof File) {
        let data = new FormData();
        data.append('file', file);
        file.file = data;
        file.url = URL.createObjectURL(file);
      }
      return file;
    });
    if (onChange) onChange(filesData);
    const newError = this.validate(filesData);
    if (onError && !Utils.equals(newError, error)) onError(newError);
  };

  render() {
    const {
      className,
      label,
      labelhtml,
      error,
      placeholder,
      disabled,
      multiple,
      required,
      accept,
      comments,
    } = this.props;

    const value = this.props.value ? this.getDefaultValue(this.props.value) : [];

    const WrapperProps = {
      className,
      label,
      labelhtml,
      error,
      required,
    };

    return (
      <InputWrapper
        { ...WrapperProps }
        className={ classNames('InputFile', {
          InputFile_Disabled: Boolean(disabled),
          InputFile_Image: accept && accept.includes('image'),
        }) }
      >
        <div className='WrapperAttachments'>
          { (value && value.length > 0) && (
            <ul className='WrapperAttachments_List'>
              { value.map((item, index) => (
                <li key={ index } className='WrapperAttachments_List_Item Table'>
                  <div className='Table'>
                    { item.file &&
                      <div className='WrapperAttachments_List_Item_Name TableCell'>
                        <a href={ item.url } target='_blank' style={ { color: ConfigService.getColor('secondaryColor') } }>
                          { this.getType(item.name) === 'image' &&
                          <img src={ item.url }/>
                          ||
                          <span>
                            <Icon className='IconFile Left Pointer' width='18' height='23' color='secondaryColor'>
                              { this.getIcon(item) }
                            </Icon>
                          { this.getName(item.name) }
                          </span>
                          }
                        </a>
                      </div>
                    }
                    { !disabled &&
                      <div className='WrapperAttachments_List_Item_Action TableCell'>
                        <div className='WrapperAttachments_List_Item_Action_Remove' onClick={ () => this.remove(index) }
                             style={ { backgroundColor: ConfigService.getColor('tertiaryColor', 0.2) } }>
                          <span style={ { color: ConfigService.getColor('tertiaryColor') } }>Remove</span>
                        </div>
                      </div>
                    }
                  </div>
                  { comments &&
                    <div className='WrapperAttachments_List_Item_Comment Table'>
                      <div className='TableCell'>
                        <Checkbox disabled={ disabled } onChange={ () => this.activeComment(index) } checked={ item.comment_active } label='Add comment'/>
                      </div>
                      <div className='TableCell Item_Comment'>
                        { item.comment_active &&
                          <InputTextArea disabled={ disabled } value={ item.comment } onChange={ (v) => this.changeComment(v, index) }/>
                        }
                      </div>
                    </div>
                  }
                </li>
              )) }
            </ul>
          ) }
          { (Utils.isNull(value) || value.length === 0 || multiple) && (
            <div className={ classNames('DropZone', {
              DropZone_Image: accept && accept.includes('image'),
            }) } style={ { color: ConfigService.getColor('tertiaryColor') } }>
              <div className='DropZone_Input'
                   style={ { backgroundColor: ConfigService.getColor('secondaryColor', 0.02) } }>
                <span>
                  <Icon className='Relative' width='24' height='20' color='tertiaryColor'>
                    { (accept && accept.includes('image')) &&
                      <PhotoIcon alt='widget-attachment-photo'/>
                      ||
                      <FileIcon alt='icon-upload'/>
                    }
                  </Icon>
                  { placeholder }
                </span>
                <input { ...this.props }
                       className='InputFile_Input'
                       type='file'
                       value={ [] }
                       onChange={ this.handleChange }
                       disabled={ disabled }
                       multiple={ multiple }
                       required={ required }
                       accept={ accept }
                />
              </div>
            </div>
          ) }
        </div>
      </InputWrapper>
    );
  }
}

InputFile.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  error: PropTypes.string,
  placeholder: PropTypes.string,
  accept: PropTypes.string,
  disabled: PropTypes.bool,
  multiple: PropTypes.bool,
  comments: PropTypes.bool,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.array,
  onError: PropTypes.func,
};

export default withShallowComparison(InputFile, ['onChange', 'onError']);
